export const ACCOUNT_UPDATE_SUCCESS_PATH = 'account-update-success'
